/** Query keys for every meeting resource. Never inline a key string. */
export const MEETING_KEYS = {
  all: ['meeting'] as const,
  detail: (meetingId: string) => ['meeting', meetingId] as const,
  participants: (meetingId: string) => ['meeting', meetingId, 'participants'] as const,
  waiting: (meetingId: string) => ['meeting', meetingId, 'waiting'] as const,
  /** The caller's OWN place in the lobby queue — not the queue itself. */
  lobbySelf: (meetingId: string) => ['meeting', meetingId, 'lobby-self'] as const,
  chat: (meetingId: string) => ['meeting', meetingId, 'chat'] as const,
  polls: (meetingId: string) => ['meeting', meetingId, 'polls'] as const,
  questions: (meetingId: string) => ['meeting', meetingId, 'questions'] as const,
  notes: (meetingId: string) => ['meeting', meetingId, 'notes'] as const,
  breakouts: (meetingId: string) => ['meeting', meetingId, 'breakouts'] as const,
  attendance: (meetingId: string) => ['meeting', meetingId, 'attendance'] as const,
} as const;
